//import axios from "../api/axios";
import useAuth from "./useAuth";
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
//import AuthContext from "../context/AuthProvider";
import useAxiosPrivate from "./useAxiosPrivate";

const useLogout = () => {
    const { setAuth, setSessionId } = useAuth();

    const axiosPrivate = useAxiosPrivate();

    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state?.from?.pathname) ? location.state?.from?.pathname + ((location.state?.search) ? location.state?.search : "") : "/" + ((location.state?.search) ? + location.state?.search : "");


    const logout = async () => {
        //setAuth({});
        //setSessionId('');



        try {
            const response = await axiosPrivate.post('/PageInfoLogout');
            setAuth({ user: response.data.user, user_ini: response.data.user_ini, access_token: response.data.access_token, menu_info: response.data.menu_info });
            setSessionId(response.data.session_id);
            navigate(from, { replace: true });
        } catch (error) {
            console.error('Erro ao realizar logout');
        }

        //window.location.reload();
        //navigate('/');
        /*try {
            const response = await axios('/logout', {
                withCredentials: true
            });
        } catch (err) {
            console.error(err);
        }*/
    }

    return logout;
}

export default useLogout